import React from 'react'

import { Box, Button, ButtonGroup, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { map } from 'lodash'
import theme from 'material/theme'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { actions } from 'store/calendar-visit-type-filter'

const useStyles = makeStyles((theme) => ({
  button: {
    padding: theme.spacing(0.75, 1),
  },
}))

export const CalendarTypeFilters = ({ typeFilters, changeFilter }) => {
  const styles = useStyles()
  return (
    <Box
      p={theme.spacing(2, 1)}
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Typography variant="subtitle2">Type</Typography>
      <ButtonGroup size="small">
        {map(
          [
            ['High School Visit', 'ignore'],
            ['College Fair', 'only'],
          ],
          ([label, val]) => (
            <Button
              className={styles.button}
              key={val}
              variant={typeFilters.collegeFair === val ? 'contained' : 'outlined'}
              color={typeFilters.collegeFair === val ? 'primary' : undefined}
              onClick={() => changeFilter({ name: 'collegeFair', value: typeFilters.collegeFair === val ? '' : val })}
            >
              {label}
            </Button>
          ),
        )}
      </ButtonGroup>
      <Typography variant="subtitle2">Format</Typography>

      <ButtonGroup size="small">
        {map(
          [
            ['In Person', 'ignore'],
            ['Virtual', 'only'],
          ],
          ([label, val]) => (
            <Button
              key={val}
              variant={typeFilters.virtual === val ? 'contained' : 'outlined'}
              color={typeFilters.virtual === val ? 'primary' : undefined}
              onClick={() => changeFilter({ name: 'virtual', value: typeFilters.virtual === val ? '' : val })}
            >
              {label}
            </Button>
          ),
        )}
      </ButtonGroup>
    </Box>
  )
}

CalendarTypeFilters.propTypes = {
  typeFilters: PropTypes.object.isRequired,
  changeFilter: PropTypes.func.isRequired,
}

export default connect(
  (state) => ({
    typeFilters: state.calendarVisitTypeFilters,
  }),
  actions,
)(CalendarTypeFilters)
